import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from "react-dom/client";  
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (_, error) => {
        if ((error as any)?.response?.status === 404) {
          return false;  // don't retry on 404 errors
        }
        return true;
      },
    },
  },
});

const root = createRoot(document.getElementById("root") as HTMLDivElement);
root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  ,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
